import { Component, Prop, Host, h, State } from '@stencil/core';
import _ from 'lodash'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import '../header-component/header-component';
import '../loader-component/loader-component'

/**
 
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/accordionlinks-component.PNG)

#### Content Type
nypwebc_ct_listitems_accordion
 */

@Component({
  tag: 'accordionlinks-component',
  styleUrl: 'accordionlinks-component.css',
  // shadow: true,
  scoped: true
})
export class AccordionlinksComponent {

  
  /**
   *Required - Unique ID.
   */
   @Prop() componentid: string = "comp-id";

   /**
   *Required - List Name.
   */
   @Prop() listname: string = "ListName";
 
   /**
   *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
   */
   @Prop() webpath: string = "/";
 
   /**
   *Required - if header attribute is true
   */
   @Prop() sectiontitle: string = "Section Title";
 
   /**
   *Required - if header attribute is true
   */
   @Prop() titleiconurl: string = "";
 
   /**
  *Optional - To show/hide header. default is true
  */
   @Prop() header: boolean = true;
 
   /**
  *Optional - vertical scroll bar
  */
   @Prop() verticalscroll: boolean = false;
 
   /**
  *Optional - vertical scroll bar height
  */
   @Prop() verticalscrollheight: number = 200;
   
   /**
  *Optional - To show see All link
  */
  @Prop() seeall: boolean = false;
  /**
 *Optional - see All Url
 */
  @Prop() seeallurl: string;
 
     /**
 *Optional - see All link Title
 */
 @Prop() seealltitle: string="See All";
 
 /**
   *Optional - number of items to retrieve
   */
   @Prop() count: number = 100;
 
     /**
 *Optional - header background color
 */
 @Prop() headerbgcolor: string ="white"
 
 /**
 *Optional -header text color
 */
 @Prop() headertextcolor: string = "black"
 /**
 *Optional -header border bottom css
 */
 @Prop() headerborderbottom: string = "1px solid #CE2127"
 
 
 /**
 *Optional - expand all by default 
 */
 @Prop() expandall: boolean =false
 
 /**
 *Optional - Expand /collapse all toggle
 */@Prop() exptoggle: boolean =false
  /**
   
   
 /**
 *Optional - Expand the first item. default is false
 */@Prop() expandfirst: boolean =false
  
  /**
  *Optional - headertext location
*/
@Prop() headerlocation:string="top";
 
 /**
  *Optional - is it SP Online site
*/
@Prop() online:boolean=false;


/**
 optional - option to sort differently. if its 2 then its alphabetical. otherwise by nypwebc_itemorder
  */
 @Prop() sortversion: number = 1;

 /**
  optional - to filter to only specific subsection. default is all 
   */
  @Prop() subsection: string = "all";

/**
 *Required - site url if its sp online site
 */
 @Prop() siteurl: string = "";

  @State() items: []
  @State() isLoading: boolean = true
  @State() expandallclick: boolean
  @State() expandbuttonclick: boolean =false

  connectedCallback() {

  }

  componentDidLoad() {
    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;

    // let siteUrl:string="";
    
    // if (this.online) {
    //   siteUrl=this.siteurl+this.webpath 
    // }
    // else
    // {
    //   siteUrl=(window as any)._spPageContextInfo.siteAbsoluteUrl+this.webpath ;
    // }


    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }
    
    const filter = "nypwebc_Active eq 1";

  
    // const config = {
    //   headers: { "Accept": "application/json; odata=verbose" }
    // };
    // let sortexpr = "&orderby=ItemOrder"
    // if (this.sortversion === 2)
    // {
    //   sortexpr = "&orderby=nypwebc_Section"
    // }
   


    return fetch(siteUrl +  "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_ItemOrder,nypwebc_Section,nypwebc_Url,nypwebc_Description&$filter=" + filter +"&$top=" + this.count, { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.isLoading = false;
        this.expandallclick = this.expandall
      });
  }


  handleClick = () => {
    this.expandallclick = !this.expandallclick
    this.expandbuttonclick=true;
    
  }
  getContents = () => {
    const contentsArray = []
    const expToggleArray = []


    if (this.exptoggle) {
      expToggleArray.push(
        <div class="row">
          <div class="col-md-12">
            <a class="float-end" onClick={this.handleClick}  target= "_blank"  data-interception="off" style={{ paddingRight: "10px", paddingTop: "5px" }}  >
              
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAABmJLR0QA/wD/AP+gvaeTAAABQ0lEQVRIie3Vv0oDQRAG8J8KmkaSdAqmsdEEH0PwHax8AiEvIIhWeQ8b64BFKh9AUEgTECtLFcFGg6DF7eHlXO9PSOkHA7dz38w37O7M8o8aWIr4trCaWb/ipUbONXwUETbxhQlGwc5qCHRxh0YRqYNxIPZqJBf4leI6GFYI2EFzHoGsSJroFnsR3gAHFXhgObd+w034nuAQFwUV9nAZeOPC8kuQHmYr4xugb76z+xMts9d9ILmmx9gP1ozEgZWKIu+59RRPWMd2sHs8V8y3eMQ6PsUujnK+K1zXFSnark/JNj1IOvhEMl5GmQJbfm/lXEgbrS858BTt4O8uSqAnab5Bwf8UpwpuWh75To6JxHhDyeQoRazCZkhYxq8kUmvYReLGZSKNOQTO/bw9E8l7tJElxPqk9GXLoR0sxRSPNeL/MYtvYfFDhGCJYBYAAAAASUVORK5CYII=" alt="Expand/collapse all"/>
              </a>
          </div>
        </div>
      )
    }

     let accordionidhash = '#' + this.componentid + '-' + 'accordion'
    // let expandbody = "accordion-collapse collapse"
    // let expandheader = "accordion-button collapsed shadow-none"

    // if (this.expandallclick) {
    //   expandbody = "accordion-collapse show"
    //   expandheader = "accordion-button shadow-none"
    // }

    // const myData = this.items.sort((a: any, b: any) => a.nypwebc_ItemOrder > b.nypwebc_ItemOrder ? 1 : -1)
    // let campuses = _.uniq(_.map(myData, 'nypwebc_Section'))

    let myData :any ={}
    if (this.sortversion ===1)
    {
     myData = this.items.sort((a: any, b: any) => a.nypwebc_ItemOrder > b.nypwebc_ItemOrder ? 1 : -1)
    }
    else if (this.subsection !== "all")
    {
      myData = this.items.sort((a: any, b: any) => a.nypwebc_SubSubSection > b.nypwebc_SubSubSection ? 1 : -1)
    }
    else{
      myData = this.items.sort((a: any, b: any) => a.nypwebc_Section > b.nypwebc_Section ? 1 : -1)
    }

    if (this.subsection !== "all")
    {
      let filtersubsection = this.subsection
      myData = _.filter(myData, function (n: any) {
        return n.ListItemAllFields.nypwebc_SubSection === filtersubsection;
      });
    }

  let campuses = [];
    
   if (this.sortversion === 2)
   {
    if (this.subsection !== "all")
    {
  
      campuses = _.uniq(_.map(myData, 'nypwebc_SubSubSection')).sort()

    }
    else 
    {
      campuses = _.uniq(_.map(myData, 'nypwebc_Section')).sort()
    }
  }
  else 
  {
    if (this.subsection !== "all")
    {
  
      campuses = _.uniq(_.map(myData, 'nypwebc_SubSubSection'))

    }
    else 
    {
      campuses = _.uniq(_.map(myData, 'nypwebc_Section'))
    }
  }



    let header = "";
    let firstItemIndex=0
    campuses.forEach((element, index) => {
      let expandbody = "accordion-collapse collapse"
      let expandheader = "accordion-button collapsed shadow-none"
  
      if (this.expandallclick) {
        expandbody = "accordion-collapse show"
        expandheader = "accordion-button shadow-none"
      }

      if (element === 'Header') {
        let descItems = _.filter(this.items, function (n: any) {
          return n.nypwebc_Section === element;
        });
        header = <p class="raw-html-style" style={{ margin: "10px 25px 10px 25px" }} innerHTML={descItems[0].nypwebc_Description}> </p>
        firstItemIndex=1
      }
      else {
    
        if (index === firstItemIndex && this.expandfirst && !this.expandbuttonclick )
        {
          expandbody = "accordion-collapse show"
          expandheader = "accordion-button shadow-none"
        }

        // else
        // {
        //   expandbody = "accordion-collapse collapse"
        //   expandheader = "accordion-button collapsed shadow-none"
        // }
    
        let idheading = this.componentid + 'heading' + index
        let idcollapsehash = '#' + this.componentid + 'collapse' + index
        let idcollapse = this.componentid + 'collapse' + index
        const contentsHeaderArray = []

        contentsHeaderArray.push(

          <h2 class="accordion-header" id={idheading}>
            <button class={expandheader} style={{ fontSize: "16px" }} type="button" data-bs-toggle="collapse" data-bs-target={idcollapsehash} aria-expanded="false" aria-controls={idcollapse}>
              {element}
            </button>
          </h2>
        )

        // let campusItems = _.filter(this.items, function (n: any) {
        //   return n.nypwebc_Section === element;
        // });

        let campusItems=[]

        if (this.subsection !== "all")
      {
        campusItems = _.filter(myData, function (n: any) {
          return n.nypwebc_SubSubSection === element;
        });
      }
      else{
        campusItems = _.filter(myData, function (n: any) {
          return n.nypwebc_Section === element;
        });
      }
      if (this.sortversion !== 1)
      {
        // campusItems= campusItems.sort((a: any, b: any) => a.Title > b.Title ? 1 : -1)

        campusItems = _.orderBy(campusItems, ['Title'],['asc']); 

      }
        const listitems = []
        for (let i = 0; i < campusItems.length; i++) {
          listitems.push(
            <li class="list-group-item"> <a  target= "_blank"  data-interception="off" href={campusItems[i].nypwebc_Url} >{campusItems[i].Title}</a></li>
          )
        }
        contentsArray.push(
          <div class="accordion-item">
            {contentsHeaderArray}
            <div id={idcollapse} class={expandbody} aria-labelledby={idheading} data-bs-parent={accordionidhash} >
              <div class="accordion-body">
                <ul class="list-group list-group-flush" style={{ borderBottomRightRadius: "10px", borderBottomLeftRadius: "10px" }}>
                  {listitems}
                </ul>
              </div>
            </div>
          </div>
        )
      }
    });
    if (header && this.headerlocation==="top") {
      contentsArray.unshift(header)
    }
    else if (header && this.headerlocation === "bottom")
    {
      contentsArray.push(header)
    }

    if (this.exptoggle) {
      contentsArray.unshift(expToggleArray)
    }
    return contentsArray

  }

  render() {


    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
        overflowX: "hidden"
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
        overflowX: "hidden"
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"
      }
    }

    let accordionid = this.componentid + '-' + 'accordion'
    return (

      this.isLoading ? <loader-component /> :
        this.header  && this.items.length > 0  ?

          <div>

            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} seeall={this.seeall} seealltitle= {this.seealltitle} seeallurl={this.seeallurl}  headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />

            <div class="row gx-0" style={parentstyle} >
              <div style={styleWithHeader}>
                <div class="accordion accordion-flush" id={accordionid}>
                  {this.getContents()}
                </div>
              </div>
            </div>
          </div>
          :

          <div class="row gx-0" style={parentstyle}  >
            <div style={style} >
              <div class="accordion accordion-flush" id={accordionid}>
                {this.getContents()}
              </div>
            </div>
          </div>
    )


  }
}
